/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRolePresetDto } from '../../models/backend-role-preset-dto';
import { BackendRolePresetCreateRequestDto } from '../../models/backend-role-preset-create-request-dto';

export interface AccessRolePresetsCreate$FormData$Params {
  body: BackendRolePresetCreateRequestDto;
}

export function accessRolePresetsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: AccessRolePresetsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendRolePresetDto>> {
  const rb = new RequestBuilder(rootUrl, accessRolePresetsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendRolePresetDto>;
    }),
  );
}

accessRolePresetsCreate$FormData.PATH = '/api/access/role-presets/';
